
















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
import { EventBus } from "@/pitprojekt/event-bus";
import GoogleMapDialog from "@/components/dialog/GoogleMapDialog.vue";
import { Product } from "@/pitprojekt/models/Product";
import { Utils } from '@/pitprojekt/utils';
import DetailedStatsTable from "@/components/table/DetailedStatsTable.vue";
import { ProductAggregatedStatDeklaracje, ProductDetailedStatDeklaracje } from "@/store/modules/statsDeklaracje/types";
import { StatsTableHeaders } from '@/views/elements/stats-table-headers'
const StatsDeklaracjeModule = namespace('StatsDeklaracjeModule')
const SettingsModule = namespace('SettingsModule')
import _ from 'lodash'

@Component({
    components: { GoogleMapDialog, DetailedStatsTable }
})
export default class StatsDeklaracjeTable extends Vue {
    @SettingsModule.Getter('selectedProduct') selectedProduct!:number;
    @SettingsModule.Getter('selectedProductObject') selectedProductObject!:Product;
    @SettingsModule.Getter('lastYear') lastYear!:boolean;
    @StatsDeklaracjeModule.Getter('detailedStatsDeklaracje') detailedStatsDeklaracje! :Array<object>;
    @StatsDeklaracjeModule.Getter('detailedStatsDeklaracjeLoading') detailedStatsDeklaracjeLoading! :boolean;
    @StatsDeklaracjeModule.Action('getDetailedStatsDeklaracjeBetweenDatesForProduct') getDetailedStatsDeklaracjeBetweenDatesForProduct: any;
    @SettingsModule.Action('changeSelectedProduct') changeSelectedProduct: any;
    expanded: Array<ProductAggregatedStatDeklaracje> = [];
    kwotaTotal: number = 0;
    kwotaAverage: number = 0;
    statsFromWindowsPercent: number = 0;
    modulPrintTotal: number = 0;
    modulEdeklaracjeTotal: number = 0;
    modulPrintPercent: number = 0;
    modulEdeklaracjePercent: number = 0;
    headers: object = StatsTableHeaders.aggregatedStatsDeklaracjeHeader();
    headersIn: object = StatsTableHeaders.detailedStatsDeklaracjeHeader();

    created() {
        this.getDetailedStatsDeklaracjeBetweenDatesForProduct({'productId': this.selectedProduct, 'lastYear': this.lastYear});
        this.changeSelectedProduct(this.$route.params.id);
        EventBus.$on('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    get aggregatedStatsDeklaracje(): Array<object> {
        let simplifiedStatsDeklaracje = _.map(this.detailedStatsDeklaracje, function(o:ProductDetailedStatDeklaracje) {
            return {'kwota': o.kwota, 'data': o.data.slice(0, 10)};
        });

        return _(simplifiedStatsDeklaracje)
            .groupBy('data')
            .map((o, key) => ({
                'data': key,
                'id': _.uniqueId('id_'),
                'kwota': _.sumBy(o, 'kwota') }))
            .value();
    }

    get detailedStatsDeklaracjeForDate() {
        let expandedDate = this.expanded[0].data;
        return  _.filter(this.detailedStatsDeklaracje, function(o:ProductDetailedStatDeklaracje) { return (o.data.slice(0, 10) === expandedDate); });
    }

    beforeDestroy() {
        EventBus.$off('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    goToStatsBrowsing() {
        this.$router.push({ name: 'stats-deklaracje-details-index', params: { id: ''+this.selectedProduct } });
    }

    pageTitleDateChanged() {
        this.getDetailedStatsDeklaracjeBetweenDatesForProduct({'productId': this.selectedProduct, 'lastYear': this.lastYear});
    }

    getProductIconName(rodzaj: string): string {
        return Utils.getProductIconName(rodzaj);
    }

    @Watch('selectedProduct')
    onSelectedProductChanged() {
        if (this.$route.params.id != this.selectedProduct.toString()) {
            this.getDetailedStatsDeklaracjeBetweenDatesForProduct({'productId': this.selectedProduct, 'lastYear': this.lastYear});
            this.$router.push({ name: 'stats-deklaracje-product', params: { id: ''+this.selectedProduct } });
        }
    }

    @Watch('expanded')
    onExpandedChanged() {
        this.kwotaTotal = 0;
        this.statsFromWindowsPercent = 0;
        this.modulPrintTotal = 0;
        this.modulEdeklaracjeTotal = 0;
        this.modulPrintPercent = 0;
        this.modulEdeklaracjePercent = 0
        this.kwotaAverage = 0;

        if (this.expanded.length > 0) {

            this.modulPrintTotal = _.countBy(this.detailedStatsDeklaracjeForDate, function(o:ProductDetailedStatDeklaracje) {return o.modul == 'DRUK'}).true;
            this.modulEdeklaracjeTotal = _.countBy(this.detailedStatsDeklaracjeForDate, function(o:ProductDetailedStatDeklaracje) {return o.modul == 'EDEKLARACJE'}).true;
            if (this.modulPrintTotal == undefined) this.modulPrintTotal = 0;
             if (this.modulEdeklaracjeTotal == undefined) this.modulEdeklaracjeTotal = 0;
            this.modulPrintPercent = (this.modulPrintTotal / this.detailedStatsDeklaracjeForDate.length) * 100;
            this.modulEdeklaracjePercent = (this.modulEdeklaracjeTotal / this.detailedStatsDeklaracjeForDate.length) * 100;
            this.kwotaTotal = _.sumBy(this.detailedStatsDeklaracjeForDate, 'kwota');
            this.kwotaAverage = this.kwotaTotal / this.detailedStatsDeklaracjeForDate.length;
            this.statsFromWindowsPercent = (_.filter(this.detailedStatsDeklaracjeForDate, function(o:ProductDetailedStatDeklaracje) { if (o.stats_uruchomienia_rozsz.os == 'Windows') return o }).length / this.detailedStatsDeklaracjeForDate.length) * 100;
        }
    }

    isWeekend(date: string):boolean {
        return Utils.isWeekend(date);
    }

    toggleExpandRow(item:ProductAggregatedStatDeklaracje) {
        this.expanded = item === this.expanded[0] ? [] : [item];
    }

    isRowExpanded(item:ProductAggregatedStatDeklaracje):boolean {
        return (item === this.expanded[0]);
    }

    showGoogleMapDialogByIP(ip: string) {
      EventBus.$emit('showGoogleMapDialogByIPEvent', ip);
    }

}
